var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalPolice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.601562,
    y: 0.142578,
    width: 70.4303,
    height: 71.4303,
    rx: 35.2151,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1006 45.3579H30.7302L21.1965 30.901V45.3579H18.826V27.1761H21.1965L30.7302 41.6069V27.1761H33.1006V45.3579ZM53.5519 32.9588C53.5519 34.0181 53.3088 34.9906 52.8225 35.8763C52.3363 36.7446 51.5896 37.4479 50.5824 37.9862C49.5752 38.5245 48.3248 38.7937 46.8314 38.7937H44.0703V45.3579H39.616V27.0719H46.8314C48.2901 27.0719 49.5231 27.3237 50.5303 27.8273C51.5375 28.3309 52.2929 29.0255 52.7965 29.9112C53.3001 30.7968 53.5519 31.8127 53.5519 32.9588ZM46.4928 35.2511C47.3437 35.2511 47.9775 35.0514 48.3943 34.652C48.8111 34.2526 49.0195 33.6882 49.0195 32.9588C49.0195 32.2295 48.8111 31.6651 48.3943 31.2657C47.9775 30.8663 47.3437 30.6666 46.4928 30.6666H44.0703V35.2511H46.4928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalPolice);
export default __webpack_public_path__ + "static/media/national-police.280b89117531580ba1b4153f356f9742.svg";
export { ForwardRef as ReactComponent };